import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

import Home from "@/pages/Home";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function ScrollToTopOnRouteChange({ children }) {
  useEffect(() => {
    const onChange = () => window.scrollTo({ top: 0, behavior: "instant" });
    onChange();
    window.addEventListener("popstate", onChange);
    return () => window.removeEventListener("popstate", onChange);
  }, []);
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTopOnRouteChange>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/packages/:slug" element={<PackageDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#1F3A5F",
                color: "#FAF4ED",
                borderRadius: 0,
                border: "1px solid rgba(232,184,155,0.4)",
              },
            }}
          />
        </ScrollToTopOnRouteChange>
      </BrowserRouter>
    </div>
  );
}

export default App;
